module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl-subheading vh-100 overflow-y-scroll ph5 pv3"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    staticStyle: {
      "margin": "0 0 10px 0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("GO BACK")]), _vm._v(" "), _c('div', {
    staticClass: "dev-border pa2"
  }, [_c('span', {
    staticClass: "titles",
    on: {
      "click": function($event) {
        return _vm.toggleEditingArea('subjects')
      }
    }
  }, [_vm._v("Subjects")]), _vm._v(" "), (_vm.currently_editing.includes('subjects')) ? _c('div', [_c('span', {
    staticClass: "ml1 pl-color-ruby"
  }, [_vm._v("(a position of 0 will exclude it from the universe home page)")]), _vm._v(" "), _c('ul', _vm._l((_vm.subjects), function(subject) {
    return _c('li', {
      key: subject.name
    }, [_c('span', {
      staticClass: "pl-title"
    }, [_vm._v(_vm._s(subject.name))]), _vm._v(" "), _c('pl-button', {
      staticClass: "pl-small pl-icon",
      nativeOn: {
        "click": function($event) {
          return _vm.editSubjectName(subject.id)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-edit"
    })]), _vm._v(" "), _c('pl-button', {
      staticClass: "pl-small pl-icon",
      nativeOn: {
        "click": function($event) {
          return _vm.deleteSubject(subject.id)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-remove"
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Position:")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (subject.position),
        expression: "subject.position"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(subject, "position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.editSubjectPosition(subject.id, $event)
        }]
      }
    }, _vm._l((_vm.subjects.length + 1), function(position, index) {
      return _c('option', {
        key: subject.name + index,
        domProps: {
          "value": index
        }
      }, [_vm._v("\n              " + _vm._s(index) + "\n            ")])
    }), 0), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.subject_to_edit_collections !== subject.name) ? _c('pl-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.getSubjectCategories(subject)
        }
      }
    }, [_vm._v("\n            Edit Collections\n          ")]) : _c('section', [_vm._v("\n            Contains following collections:\n            "), _vm._l((_vm.categories_with_subjects), function(category, index) {
      return _c('div', {
        key: subject.name + category.name,
        staticClass: "flex cat-container"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (category.subject_position),
          expression: "category.subject_position"
        }],
        staticClass: "cat-position",
        style: ({
          visibility: _vm.subjectCategoryIsSelected(subject, category) ?
            'visible' :
            'hidden',
        }),
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(category, "subject_position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.categories_with_subjects.length + 1), function(position, index) {
        return _c('option', {
          key: category.name + index,
          domProps: {
            "value": index
          }
        }, [_vm._v("\n                  " + _vm._s(index) + "\n                ")])
      }), 0), _vm._v(" "), _c('pl-checkbox', {
        ref: "'checkbox' + index",
        refInFor: true,
        attrs: {
          "value": category
        },
        model: {
          value: (subject.collections),
          callback: function($$v) {
            _vm.$set(subject, "collections", $$v)
          },
          expression: "subject.collections"
        }
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(category.name))])], 1)
    }), _vm._v(" "), _c('pl-button', {
      staticClass: "pl-primary",
      nativeOn: {
        "click": function($event) {
          return _vm.saveSubjectCollections(subject.id)
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('pl-button', {
      staticClass: "pl-secondary",
      nativeOn: {
        "click": function($event) {
          _vm.subject_to_edit_collections = ''
        }
      }
    }, [_vm._v("Close")])], 2), _vm._v(" "), _c('hr')], 1)
  }), 0), _vm._v(" "), _c('div', {}, [_c('span', {
    staticClass: "titles"
  }, [_vm._v("Create New Subject")]), _vm._v(" "), _c('pl-input', {
    model: {
      value: (_vm.new_subject),
      callback: function($$v) {
        _vm.new_subject = $$v
      },
      expression: "new_subject"
    }
  }), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    attrs: {
      "disabled": !_vm.new_subject
    },
    nativeOn: {
      "click": function($event) {
        return _vm.createNewSubject.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Add new\n        ")])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dev-border pa2"
  }, [_c('span', {
    staticClass: "titles",
    on: {
      "click": function($event) {
        return _vm.toggleEditingArea('grades')
      }
    }
  }, [_vm._v("Grades")]), _vm._v(" "), (_vm.currently_editing.includes('grades')) ? _c('div', [_c('ul', _vm._l((_vm.grades), function(grade) {
    return _c('li', {
      key: grade.id
    }, [_vm._v("\n          " + _vm._s(grade.grade) + "\n          "), _c('pl-button', {
      staticClass: "pl-small pl-icon",
      nativeOn: {
        "click": function($event) {
          return _vm.editGrade(grade)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-edit"
    })]), _vm._v(" "), _c('pl-button', {
      staticClass: "pl-small pl-icon",
      nativeOn: {
        "click": function($event) {
          return _vm.deleteGradeLevel(grade)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times delete-answer"
    })])], 1)
  }), 0), _vm._v(" "), _c('div', {}, [_c('span', {
    staticClass: "titles"
  }, [_vm._v("Create New Grade")]), _vm._v(" "), _c('pl-input', {
    model: {
      value: (_vm.new_grade),
      callback: function($$v) {
        _vm.new_grade = $$v
      },
      expression: "new_grade"
    }
  }), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    attrs: {
      "disabled": !_vm.new_grade
    },
    nativeOn: {
      "click": function($event) {
        return _vm.createNewGrade.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Add new\n        ")])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dev-border pa2"
  }, [_c('span', {
    staticClass: "titles",
    on: {
      "click": function($event) {
        return _vm.toggleEditingArea('skills')
      }
    }
  }, [_vm._v("Skills")]), _vm._v(" "), (_vm.currently_editing.includes('skills')) ? _c('div', [_c('ul', _vm._l((_vm.skills), function(skill) {
    return _c('li', {
      key: skill.id
    }, [_vm._v("\n          " + _vm._s(skill.name) + "\n          "), _c('pl-button', {
      staticClass: "pl-small pl-icon",
      nativeOn: {
        "click": function($event) {
          return _vm.editSkill(skill)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-edit"
    })]), _vm._v(" "), _c('pl-button', {
      staticClass: "pl-small pl-icon",
      nativeOn: {
        "click": function($event) {
          return _vm.deleteSkill(skill)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times delete-answer"
    })])], 1)
  }), 0), _vm._v(" "), _c('div', {}, [_c('span', {
    staticClass: "titles"
  }, [_vm._v("Create New Skill")]), _vm._v(" "), _c('pl-input', {
    model: {
      value: (_vm.new_skill),
      callback: function($$v) {
        _vm.new_skill = $$v
      },
      expression: "new_skill"
    }
  }), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    attrs: {
      "disabled": !_vm.new_skill
    },
    nativeOn: {
      "click": function($event) {
        return _vm.createNewSkill.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Add new\n        ")])], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-aadae33e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminUniverseSettings.vue
// module id = 1931
// module chunks = 61